import React from 'react';

/**
 * Component for displaying text with karaoke-style word highlighting.
 *
 * @param {Array} wordTimings - Word timing data [{word, start, end}, ...]
 * @param {number} currentWordIndex - Index of currently highlighted word (-1 for none)
 * @param {Object} style - Optional custom styling
 * @param {string} highlightColor - Background color for highlighted word (default: #fff3cd)
 * @param {string} textColor - Text color (default: #2c3e50)
 */
const KaraokeText = ({
  wordTimings,
  words,
  currentWordIndex,
  style = {},
  highlightColor = '#fff3cd',
  textColor = '#2c3e50',
  className = ''
}) => {
  const items = wordTimings || (words ? words.map(w => ({ word: w })) : null);

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <span style={{ display: 'contents', ...style }} className={className}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <span
            style={{
              backgroundColor: currentWordIndex === index ? highlightColor : 'transparent',
              padding: '1px 2px',
              borderRadius: '3px',
              transition: 'background-color 0.15s ease-in-out',
              color: textColor,
            }}
          >
            {item.word}
          </span>
          {index < items.length - 1 ? ' ' : ''}
        </React.Fragment>
      ))}
    </span>
  );
};

export default KaraokeText;
